import Vue from 'vue';
import Card from './Card';
import store from '@/store';
import Dot from './Dot';
/**
 * 车型价格信息牌
 * @param {*} elementId
 * @param {*} param1
 */
function createPriceBoard(
  elementId,
  {
    hotspotId,
    seriesId,
    specId,
    salesInfo,
    seriesName,
    specName,
    dealerNewPrice,
    maxOriginalPrice,
    downPrice,
    score,
    has3d,
    sceneName,
    facRebateAmount,
    jumpUrl,
    position,
  },
  panoComponent,
) {
  const CardApp = Vue.extend(Card);
  if (!CardApp.prototype.$panoComponent) {
    CardApp.prototype.$panoComponent = panoComponent;
  }
  const app = new CardApp({
    propsData: {
      hotspotId,
      seriesId,
      specId,
      salesInfo,
      seriesName,
      specName,
      dealerNewPrice,
      maxOriginalPrice,
      downPrice,
      score,
      has3d,
      sceneName,
      facRebateAmount,
      jumpUrl,
      position,
    },
    store,
  });
  app.$mount(document.getElementById(elementId));
}

function createDot(
  elementId,
  {
    hotspotId,
    seriesId,
    specId,
    salesInfo,
    seriesName,
    specName,
    downPrice,
    score,
    has3d,
    sceneName,
    facRebateAmount,
    jumpUrl,
    position,
    typeId,
  },
  panoComponent,
) {
  const DotApp = Vue.extend(Dot);
  if (!DotApp.prototype.$panoComponent) {
    DotApp.prototype.$panoComponent = panoComponent;
  }
  const app = new DotApp({
    propsData: {
      hotspotId,
      seriesId,
      specId,
      salesInfo,
      seriesName,
      specName,
      downPrice,
      score,
      has3d,
      sceneName,
      facRebateAmount,
      jumpUrl,
      position,
      typeId,
    },
    store,
  });
  app.$mount(document.getElementById(elementId));
}

export { createPriceBoard, createDot };
